// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".productTags{margin-bottom:1rem;margin-left:-1rem;margin-right:-1rem}@media(max-width:600px){.productTags{margin-left:-.5rem;margin-right:-.5rem}}.productTags__tag{border-left:1px solid #e6e6e6;padding-left:1rem;padding-right:1rem}@media(max-width:600px){.productTags__tag{padding-left:.5rem;padding-right:.5rem}}.productTags__tag:first-child{border-left:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
